import { createContext } from 'react';
import type {
  PermissionAction,
  PermissionResourceKey,
  Role,
} from '@/authorization/types';

export interface AuthorizationContextValue {
  roles: Role[];
  selectedRoleId: string | null;
  selectedRole: Role | null;
  resolvedPermissions: Set<string>;
  isLoading: boolean;
  hasPermission: (permission: string) => boolean;
  canAccess: (
    resource: PermissionResourceKey,
    action: PermissionAction,
  ) => boolean;
  setSelectedRoleId: (roleId: string) => void;
  updatePermission: (
    roleId: string,
    resource: PermissionResourceKey,
    action: PermissionAction,
    allowed: boolean,
  ) => void;
  grantAll: (roleId: string) => void;
  revokeAll: (roleId: string) => void;
  resetRolePermissions: (roleId: string) => void;
  toggleResourceRow: (
    roleId: string,
    resource: PermissionResourceKey,
    allowed: boolean,
  ) => void;
  toggleActionColumn: (
    roleId: string,
    action: PermissionAction,
    allowed: boolean,
  ) => void;
  refreshRoles: () => Promise<void>;
}

export const AuthorizationContext = createContext<
  AuthorizationContextValue | undefined
>(undefined);
